// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5103":"72d16068","5959":"72d16068","6290":"a72842ec"}[chunkId] + ".chunk.css";
};